<template><main class="home"></main></template>

<style lang="css" scoped>
  main.home {
    display: none;
    pointer-events: none;
    /* scroll-behavior: none; */
    overflow: hidden;
  }
</style>